var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagsWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.9974H18.3327M1.66602 9.9974C1.66602 14.5998 5.39698 18.3307 9.99935 18.3307M1.66602 9.9974C1.66602 5.39502 5.39698 1.66406 9.99935 1.66406M18.3327 9.9974C18.3327 14.5998 14.6017 18.3307 9.99935 18.3307M18.3327 9.9974C18.3327 5.39502 14.6017 1.66406 9.99935 1.66406M9.99935 1.66406C12.0837 3.94602 13.2683 6.90742 13.3327 9.9974C13.2683 13.0874 12.0837 16.0488 9.99935 18.3307M9.99935 1.66406C7.91495 3.94602 6.73039 6.90742 6.66602 9.9974C6.73039 13.0874 7.91495 16.0488 9.99935 18.3307",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsWebsite);
export default __webpack_public_path__ + "static/media/tags-website.4bd3649fd9b9a9239e0d31bf72616386.svg";
export { ForwardRef as ReactComponent };